import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class OfferRequestItemDialog {
  constructor($scope, $rootScope, OfferRequestItemService, UserService, UiService) {
    function load_contacts(user_id) {
      UserService.get_contacts(user_id).success(function(data) {
        $scope.contacts = data.contacts;
      });
    }

    $scope.$on('show_offer_request_item_dialog', function(event, data) {
      $scope.item = angular.copy(data.item);
      $scope.edit_items = data.items || null;
      if ($scope.item.supplier_id)
        load_contacts($scope.item.supplier_id);
      else
        $scope.contacts = [];
      window.openFancyboxDialog('div#offer_request_item_dialog');
    });

    $scope.save = function() {
      $scope.saving = true;
      if (!$scope.edit_items) {
        OfferRequestItemService.save($scope.item).success(function(data) {
          if (data.success) {
            $rootScope.$broadcast('load_items');
            $scope.saving = false;
            $.fancybox.close();
          }
        });
      } else {
        OfferRequestItemService.mass_save($scope.item, $scope.edit_items).success(function(data) {
          if (data.success) {
            $rootScope.$broadcast('load_items', {
              selected_items: $scope.edit_items,
              item_key: 'id'
            });
            $scope.saving = false;
            $.fancybox.close();
          }
        });
      }
    };

    $scope.init = function() {
      $scope.date_options = UiService.dateOptions;
      $scope.status_options = _.filter(OfferRequestItemService.get_status_options(), function(o) {
        return o.id < 3;
      });
    };

    $scope.init();
  }
}

OfferRequestItemDialog.$inject = ['$scope', '$rootScope', 'OfferRequestItemService', 'UserService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-request-item-dialog.ctrl.js